<template>
  <div
    class="work-flow-task-bar workflow-font-family"
    :class="{ 'is-fixed': !isFloating }"
  >
    <div class="title-wrapper" v-if="!isFloating">
      <div class="task-bar-title">Module</div>
      <div class="close-container" @click="$emit('setTaskbarMode', 'floating')">
        <div>
          <i class="fa fa-times"></i>
        </div>
      </div>
    </div>
    <div
      v-else
      class="expand-container"
      @click="$emit('setTaskbarMode', 'static')"
    >
      <svg
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="expand-icon"
        v-if="isFloatingToggleVisible"
      >
        <path
          d="M3.5403 3.17747L7.78184 3.06406L7.66843 7.3056M7.47941 3.36649L5.27169 5.57421L3.06398 7.78192"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect x="0.5" y="0.5" width="10" height="10" rx="1.5" stroke="black" />
      </svg>
    </div>
    <div class="task-list-wrapper">
      <div class="search-bar">
        <img src="../../assets/img/work-flow-icons/search.svg" alt="search" />
        <input placeholder="Suche" v-model="taskFilter" @input="onSearch" />
      </div>
      <div
        class="task-list fancy-scroll"
        ref="processTaskBarRef"
        :class="{
          disabled: !isUserHasAccess,
        }"
        @scroll.passive="showScrollbar"
        :style="getDynamicHeight"
      >
        <div
          class="overlay"
          ref="taskOverlay"
          v-show="
            !isFloating && getFilteredTasks && getFilteredTasks.length > 0
          "
        ></div>
        <div
          class="task position-relative"
          v-for="(task, i) in getFilteredTasks"
          :key="i"
          @click="addTask(task)"
          @mouseover="!isFloating && onTaskMouseOver(i, $event)"
          :ref="`workflowTasks${i}`"
          @mouseout="onTaskMouseOut"
          :class="{ hover: isFloating }"
        >
          <div class="task-icon-wrapper">
            <img :src="getTaskIcon(task)" class="task-icon" alt="task-icon" />
          </div>
          <div v-tooltip="getTooltipSetting(task)" class="task-data-wrapper">
            <div class="task-title">{{ task.caption }}</div>

            <div class="task-description">
              {{ getTaskDescription(task) }}
            </div>
          </div>
          <div
            v-if="task.name === 'CustomCode'"
            class="task-tools-container position-absolute h-100 d-flex flex-row align-items-center justify-content-center gap-2"
          >
            <i
              @click.stop="onClickTool('edit', task)"
              class="fas fa-edit"
              v-b-tooltip.hover
              title="Bearbeiten"
            ></i>

            <i
              @click.stop="onClickTool('delete', task)"
              class="fas fa-trash"
              v-b-tooltip.hover
              title="Löschen"
            ></i>
          </div>
        </div>
        <div class="task" v-if="getFilteredTasks.length === 0">
          Keine passenden Aufgaben gefunden
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getFlowLastId,
  debouncer,
  getApiEndpointVersion,
  getIsVueBasedFormBuilder,
} from '@/utils/helpers';
import {
  getValidatedTasksPosition,
  getEndTaskList,
} from '@/utils/helpers/WorkFlowHelpers';
export default {
  name: 'WorkFlowTaskBar',
  data() {
    return {
      taskFilter: '',
    };
  },
  props: {
    process: {
      type: Object,
      required: true,
    },
    tasksArray: {
      type: Array,
      required: true,
    },
    tasksMiscData: {
      type: Object,
      required: true,
    },
    isUserHasAccess: {
      type: Boolean,
      required: true,
      default: false,
    },
    customTasksList: {
      type: Array,
      required: true,
    },
    isFloating: {
      type: Boolean,
      default: false,
      required: false,
    },
    currentTaskId: {
      type: Number | String,
      required: false,
    },
    taskInsertDirection: {
      type: String,
      required: false,
    },
  },
  methods: {
    onTaskMouseOut() {
      if (!this.isFloating) {
        const overlay = this.$refs.taskOverlay;
        overlay.classList.remove('active');
      }
    },
    onTaskMouseOver(index, event) {
      if (event.target.classList.contains('workflow-tooltip-content')) return;
      const processTaskBarRef = this.$refs.processTaskBarRef;
      const rect = processTaskBarRef.getBoundingClientRect();
      let position =
        this.$refs[`workflowTasks${index}`][0].getBoundingClientRect();
      const overlay = this.$refs.taskOverlay;
      overlay.classList.add('active');
      overlay.style.left = position.x - rect.x + 'px';
      overlay.style.top =
        position.y - rect.y + processTaskBarRef.scrollTop + 'px';
      overlay.style.height = position.height + 'px';
      overlay.style.width = position.width + 'px';
    },
    addTask(t, shouldActivate = true) {
      if (this.isUserHasAccess) {
        const task = JSON.parse(JSON.stringify(t));
        task.id = getFlowLastId(this);

        const taskCount = this.process.tasks.length;
        let taskX = 0,
          taskY = 0;

        if (!this.isFloating) {
          if (taskCount > 0) {
            const potentialLastTask = this.process.tasks.filter((el) => {
              return !this.process.tasks.some(
                (ele) => ele.previousTaskId === el.id
              );
            });

            const lastTask = potentialLastTask[potentialLastTask.length - 1];

            if (lastTask.name === 'Condition') {
              task.pathType = 'true';
              task.previousTaskId = lastTask.id;
              taskX = lastTask.shape.x + 200;
              taskY = lastTask.shape.y - 200;
            } else if (
              lastTask.hasOwnProperty('pathType') &&
              lastTask.pathType.toString() === 'true'
            ) {
              task.pathType = 'false';
              task.previousTaskId = lastTask.previousTaskId;
              taskX = lastTask.shape.x + 200;
              taskY = lastTask.shape.y - 200;
            } else {
              task.previousTaskId = lastTask.id;
              taskX = lastTask.shape.x + 200;
              taskY = lastTask.shape.y + (taskCount % 2 == 0 ? -200 : 200);
            }
            task.input = lastTask.output;
            task.output = lastTask.output;
          } else {
            taskX = 400;
            taskY = 200;
          }

          const { x, y } = getValidatedTasksPosition(taskX, taskY, task.name);

          task.shape = {
            ...task.shape,
            x,
            y,
          };

          this.process.tasks.push(task);

          const endTasks = getEndTaskList();
          if (endTasks.includes(task.name)) {
            this.$emit('onClose');
          }
          if (shouldActivate) {
            this.$emit('onTaskAdd', task);
          }
        } else {
          const activeTaskId = this.currentTaskId;
          const optionType = this.taskInsertDirection;
          const activeCurrentTask = this.process.tasks.find(
            (t) => t.id == activeTaskId
          );
          if (optionType == 'left') {
            taskX = activeCurrentTask.shape.x - 200;
            taskY =
              activeCurrentTask.shape.y + (taskCount % 2 == 0 ? -150 : 150);
          }

          if (optionType == 'right') {
            taskX = activeCurrentTask.shape.x + 200;
            taskY =
              activeCurrentTask.shape.y + (taskCount % 2 == 0 ? -150 : 150);
          }
          if (optionType == 'top') {
            taskX = activeCurrentTask.shape.x + 200;
            taskY = activeCurrentTask.shape.y - 150;
          }

          if (optionType == 'bottom') {
            taskX = activeCurrentTask.shape.x + 200;
            taskY = activeCurrentTask.shape.y + 150;
          }

          const { x, y } = getValidatedTasksPosition(taskX, taskY, task.name);
          task.shape = {
            ...task.shape,
            x,
            y,
          };
          let tasks = structuredClone(this.process.tasks);
          tasks.push(task);

          const targetTaskID = tasks.findIndex((el) => el.id === task.id);
          const currentTaskID = tasks.findIndex((el) => el.id === activeTaskId);

          const getChildTaskIndex = (taskId) => {
            return tasks.findIndex((el) => el.previousTaskId === taskId);
          };

          const childTaskID = getChildTaskIndex(tasks[currentTaskID].id);

          if (optionType === 'left') {
            tasks[targetTaskID].previousTaskId =
              tasks[currentTaskID].previousTaskId;
            tasks[currentTaskID].previousTaskId = tasks[targetTaskID].id;

            // path type changed
            if (tasks[currentTaskID].hasOwnProperty('pathType')) {
              tasks[targetTaskID].pathType = tasks[currentTaskID].pathType;
              delete tasks[currentTaskID].pathType;
            }
          }

          if (optionType === 'right') {
            // check have childTasks
            if (childTaskID >= 0) {
              if (tasks[targetTaskID].name === 'Condition') {
                this.$set(tasks[childTaskID], 'pathType', true);
              }
              tasks[childTaskID].previousTaskId = tasks[targetTaskID].id;
            }
            tasks[targetTaskID].previousTaskId = tasks[currentTaskID].id;
          }

          if (optionType === 'top') {
            task.pathType = 'true';
            task.previousTaskId = tasks[currentTaskID].id;
          }

          if (optionType === 'bottom') {
            task.pathType = 'false';
            task.previousTaskId = tasks[currentTaskID].id;
          }
          this.process.tasks = [...tasks];
          this.$emit('onClose');
        }
      }
    },
    getTaskIcon(task) {
      if (task.customIcon) {
        return task.customIcon;
      }
      if (this.customTasksList.includes(task.name)) {
        return task.icon;
      }
      return require(`../../assets/img/work-flow-icons/task-icons/${
        this.tasksMiscData[task.name].style.icon
      }`);
    },
    onSearch() {
      const overlay = this.$refs.taskOverlay;
      overlay.classList.remove('active');
      overlay.style.top = 0;
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    getTaskDescription(task) {
      if (this.customTasksList.includes(task.name)) {
        return task?.props?.description;
      } else return this.tasksMiscData[task.name]?.description;
    },

    filterOutEndTasks(tasks) {
      const endTasks = getEndTaskList();
      return tasks.filter((el) => !endTasks.includes(el.name));
    },
    getTooltipSetting(task) {
      return {
        text: this.getTaskDescription(task),
        width: 260,
        maxHeight: 200,
        offsetX: 25,
        position: 'right',
        positionContainer: true,
        align: 'bottom',
        auto: true,
        bgColor: '#333343',
        disabled: task.name !== 'CustomCode',
        parentContainer: 'workflowTaskBar',
      };
    },
    onClickTool(action, task) {
      this.$emit('onCustomTaskActionTrigger', action, task);
    },
  },
  computed: {
    getActiveTasks() {
      return [...this.tasksArray].filter(
        (el) => this.tasksMiscData[el.name]?.isActive
      );
    },
    getFilteredTasks() {
      let tasks = [...this.getActiveTasks];
      const isVueBasedFormbuilder = getIsVueBasedFormBuilder(this.process);
      let flowRunnerVersion = getApiEndpointVersion(
        isVueBasedFormbuilder
          ? this.process?.settings?.executionEndPoint
          : this.process?.settings?.apiEndpoint
      );
      if (flowRunnerVersion < 7) {
        tasks = tasks.filter((el) => el.name !== 'Form');
      }
      if (flowRunnerVersion < 8) {
        tasks = tasks.filter(
          (el) => !['RemoveItem', 'SpreadSheet'].includes(el.name)
        );
      }

      if (this.isFloating && ['left'].includes(this.taskInsertDirection)) {
        tasks = tasks.filter((el) => el.name !== 'Condition');
      }
      if (
        !['bottom', 'top'].includes(this.taskInsertDirection) &&
        this.isFloating
      ) {
        const lastTasks = this.process.tasks.filter((el) => {
          return !this.process.tasks.some(
            (ele) => ele.previousTaskId === el.id
          );
        });
        const isLastTaskPosition = lastTasks.some(
          (ele) => ele.id === this.currentTaskId
        );
        if (!isLastTaskPosition) {
          tasks = this.filterOutEndTasks(tasks);
        }
      }

      if (this.isFloating && ['left'].includes(this.taskInsertDirection)) {
        tasks = this.filterOutEndTasks(tasks);
      }

      if (this.taskFilter && this.taskFilter.trim() !== '') {
        return tasks.filter((el) =>
          el.caption
            .trim()
            .toLocaleLowerCase()
            .includes(this.taskFilter.trim().toLocaleLowerCase())
        );
      }

      return tasks;
    },
    getDynamicHeight() {
      return {
        'max-height': `calc(100dvh - ${this.isFloating ? 235 : 330}px)`,
      };
    },
    isFloatingToggleVisible() {
      const endTasks = getEndTaskList();
      return (
        this.isFloating &&
        !this.process.tasks.some((task) => endTasks.includes(task.name))
      );
    },
  },
  emits: ['onTaskAdd'],
};
</script>
<style scoped>
.work-flow-task-bar {
  width: 346px;
  top: 115px;
  right: 18px;
  z-index: 2;
  background: #fff;
  box-shadow: 2px 8px 20px 2px #00000012;
  -webkit-box-shadow: 2px 8px 20px 2px #00000012;
  -moz-box-shadow: 2px 8px 20px 2px #00000012;
  transform: translateX(0%);
  display: flex;
  flex-direction: column;
  gap: 33px;
  border-radius: 7px;
  transition: all 0.3s ease;
  user-select: none;
}
.work-flow-task-bar.is-fixed {
  position: fixed;
}

.work-flow-task-bar .title-wrapper {
  border-bottom: 1px solid #ececed;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: space-between;
  padding: 0 26px;
  height: 70px;
}

.work-flow-task-bar .expand-container .expand-icon {
  position: absolute;
  right: 10px;
  top: 13px;
  cursor: pointer;
}

.work-flow-task-bar .task-bar-title {
  font-size: 22px;
  font-weight: 500;
  color: #333343;
  line-height: 36px;
}

.work-flow-task-bar .title-wrapper .close-container {
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: -15px;
  margin-right: -10px;
}

.work-flow-task-bar .title-wrapper .close-container img {
  width: 20px;
}

.work-flow-task-bar .task-list-wrapper {
  flex-grow: 1;
  padding: 0 8px 22px 8px;
  display: flex;
  flex-flow: column;
  gap: 35px;
  height: calc(100% - 150px);
}

.work-flow-task-bar .search-bar {
  border: 1px solid #97979e;
  display: flex;
  padding: 7px 10px;
  gap: 10px;
  justify-content: center;
  align-items: center;
  background: white;
  border-radius: 5px;
  width: 100%;
  height: 36px;
  margin: 0 auto;
  max-width: 302px;
}

.work-flow-task-bar .search-bar input {
  width: 100%;
  padding: 0;
  border: none;
  border-radius: 3px;
  padding: 4px 0px;
  background: #ffffff;
  color: #444f62;
  font-size: 18px;
}

.work-flow-task-bar .search-bar input::placeholder {
  font-size: 18px;
  color: #c3c3c6;
}
.work-flow-task-bar .search-bar input:focus {
  outline: none;
}

.work-flow-task-bar .search-bar img {
  height: 22px;
  width: 22px;
}

.work-flow-task-bar .task-list-wrapper .task-list {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  position: relative;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 0 14px;
  border-radius: 9px;
  margin: 0 0;
}

.work-flow-task-bar .task-list-wrapper .task-list .overlay {
  position: absolute;
  background-color: #efefef;
  z-index: -1;
  transition: 0.3s ease all;
  border-radius: 9px;
  opacity: 0;
  width: 314px !important;
  left: 50% !important;
  transform: translateX(-50%);
}
.work-flow-task-bar .task-list-wrapper .task-list .overlay.active {
  opacity: 1;
}

.work-flow-task-bar .task-list-wrapper .task-list .task {
  border-radius: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 22px;
  padding: 0;
}

.work-flow-task-bar .task-list-wrapper .task-list .task.hover:hover {
  background-color: #efefef;
  margin: 0 -10px;
  padding: 0 10px;
  transition: all 0.5s ease;
}
.work-flow-task-bar .task-list-wrapper .task-list .task .task-tools-container {
  background-color: #ffffff;
  right: 4px;
  padding: 0 10px;
  opacity: 0;
}
.work-flow-task-bar .task-list-wrapper .task:hover .task-tools-container {
  opacity: 1;
  background-color: #efefef;
  transition: all 0.5s ease;
}

.work-flow-task-bar
  .task-list-wrapper
  .task-list
  .task:hover
  .task-icon-wrapper {
  border-color: #efefef;
  transition: 0.3s ease all;
}
.work-flow-task-bar .task-list-wrapper .task-list .task:last-child {
  margin-bottom: 0;
}

.work-flow-task-bar .task-list-wrapper .task-list .task .task-icon-wrapper {
  height: 52px;
  display: flex;
  width: 52px;
  justify-content: center;
  align-items: center;
  min-width: 50px;
  padding: 0;
  border: 0.5px solid #e7e7e7;
  border-radius: 9px;
}

.work-flow-task-bar
  .task-list-wrapper
  .task-list
  .task
  .task-icon-wrapper
  .task-icon {
  max-width: 100%;
  object-fit: contain;
  height: 55%;
  width: 55%;
}

.work-flow-task-bar .task-list-wrapper .task-list .task .task-title {
  font-size: 13px;
  font-weight: 500;
  line-height: 15px;
  color: #333343;
}

.work-flow-task-bar .task-list-wrapper .task-list .task .task-description {
  line-height: 12px;
  font-size: 11px;
  margin-top: 5px;
  color: #333343;
  padding-right: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.work-flow-task-bar .task-list-wrapper .task-list.disabled .task {
  cursor: default !important;
}
</style>
